// 링크 타고 들어온 회원이 입회상담 등록하는 곳
export const URL_NON_MEMBER_JOIN_ADD = '/join-counsel/add';

// 게시판
export const URL_BOARD = '/board';
export const URL_BOARD_TASK = `${URL_BOARD}/task`; // 업무게시판
export const URL_BOARD_TASK_DETAIL = `${URL_BOARD_TASK}/:no`; // 업무게시판 상세
export const URL_BOARD_TASK_EDIT = `${URL_BOARD_TASK}/edit/:no`; // 업무게시판 상세
export const URL_BOARD_TASK_ADD = `${URL_BOARD_TASK}/add`; // 업무게시판 상세
export const URL_BOARD_CLASS = `${URL_BOARD}/class`; // 수업자료
export const URL_BOARD_CLASS_DETAIL = `${URL_BOARD_CLASS}/:no`; // 수업자료 상세
export const URL_BOARD_CLASS_ADD = `${URL_BOARD_CLASS}/add`; // 수업자료 등록
export const URL_BOARD_CLASS_EDIT = `${URL_BOARD_CLASS}/edit/:no`; // 수업자료 등록
export const URL_BOARD_CLASS_CAT_ADD = `${URL_BOARD_CLASS}/category/add`; // 수업자료 카테고리 추가
export const URL_BOARD_BANNER = `${URL_BOARD}/banner`; // 배너관리

// 업무서식
export const URL_TASK_FORM = '/task-form';
export const URL_TASK_FORM_MAIN = `${URL_TASK_FORM}/form`; // 서식
export const URL_TASK_FORM_DETAIL = `${URL_TASK_FORM}/:no`;
export const URL_TASK_FORM_EDIT = `${URL_TASK_FORM}/edit/:no`;
export const URL_TASK_FORM_ADD = `${URL_TASK_FORM}/add`;

// 고객센터
export const URL_CUSTOMER_CENTER = '/customer-center';
export const URL_CUSTOMER_CENTER_INQUIRY = `${URL_CUSTOMER_CENTER}/inquiry`; // 문의
export const URL_CUSTOMER_CENTER_INQUIRY_DETAIL = `${URL_CUSTOMER_CENTER}/inquiry/:no`;     // 문의 상세 
export const URL_CUSTOMER_CENTER_INQUIRY_ADD = `${URL_CUSTOMER_CENTER}/inquiry/add`;        // 문의 등록
export const URL_CUSTOMER_CENTER_INQUIRY_EDIT = `${URL_CUSTOMER_CENTER}/inquiry/edit/:no`;  // 문의 수정
export const URL_CUSTOMER_CENTER_FAQ = `${URL_CUSTOMER_CENTER}/faq`; // FAQ
export const URL_CUSTOMER_CENTER_FAQ_DETAIL = `${URL_CUSTOMER_CENTER}/faq/:no`; // FAQ 상세
export const URL_CUSTOMER_CENTER_FAQ_ADD = `${URL_CUSTOMER_CENTER}/faq/add`; // FAQ 수정
export const URL_CUSTOMER_CENTER_FAQ_EDIT = `${URL_CUSTOMER_CENTER}/faq/edit/:no`; // FAQ 수정
export const URL_CUSTOMER_CENTER_PRODUCT_FAQ = `${URL_CUSTOMER_CENTER}/product-faq`; // FAQ(물품)

//임시
export const URL_BOARD_CLASS_TYPE1 = `${URL_BOARD_CLASS}/type1`;
export const URL_BOARD_CLASS_TYPE2 = `${URL_BOARD_CLASS}/type2`;
export const URL_BOARD_CLASS_TYPE3 = `${URL_BOARD_CLASS}/type3`;
export const URL_BOARD_CLASS_TYPE4 = `${URL_BOARD_CLASS}/type4`;